const telegramLink = 'https://t.me/MC_WOJAK'
const twitterLink = 'https://twitter.com/mc_wojak'

export { telegramLink, twitterLink }